module.exports = __webpack_public_path__ + "static/img/face_2.1413c74d.webp";